export default import.meta.ROLLUP_FILE_URL_fC5bXV1pUpWgN$jwdbwP8Q